module.exports = __webpack_public_path__ + "static/media/ijs-tapas-2.257f1e98.jpeg";